export class TimeSpentModel{
    id:number;
    isRecordTime:boolean;
    timeSpent:number;

    constructor(){
        this.id = 0;
        this.isRecordTime = false;
        this.timeSpent = 0;
    }
}